import React from 'react';
import { fmtAED, fmtDate } from '../lib/format';

export default function InvoiceView({ invoice, footer }) {
  return (
    <div className="bg-white text-black rounded-lg p-4 text-sm font-mono" data-testid="invoice-view">
      <div className="text-center border-b border-dashed border-gray-400 pb-2 mb-2">
        <div className="font-bold text-base">{invoice.outlet_name}</div>
        <div className="text-xs">{invoice.outlet_address}</div>
        <div className="text-xs">TRN: {invoice.trn || '—'}</div>
        <div className="font-bold mt-1">TAX INVOICE</div>
      </div>
      <div className="flex justify-between text-xs mb-1"><span>Invoice</span><span data-testid="invoice-no">{invoice.invoice_no}</span></div>
      <div className="flex justify-between text-xs mb-2"><span>Date</span><span>{fmtDate(invoice.created_at)}</span></div>
      <table className="w-full text-xs border-t border-b border-dashed border-gray-400 py-1">
        <thead><tr className="text-left"><th className="py-1">Item</th><th className="text-center">Qty</th><th className="text-right">Total</th></tr></thead>
        <tbody>
          {invoice.items.map((it, i) => (
            <tr key={i}><td className="py-0.5">{it.name}</td><td className="text-center">{it.qty}</td><td className="text-right">{fmtAED(it.line_total)}</td></tr>
          ))}
        </tbody>
      </table>
      <div className="space-y-0.5 mt-2 text-xs">
        <div className="flex justify-between"><span>Subtotal</span><span>{fmtAED(invoice.subtotal)}</span></div>
        {invoice.discount > 0 && <div className="flex justify-between"><span>Discount</span><span>-{fmtAED(invoice.discount)}</span></div>}
        <div className="flex justify-between"><span>VAT ({Math.round((invoice.vat_rate || 0.05) * 100)}%)</span><span>{fmtAED(invoice.vat_total)}</span></div>
        {invoice.service_charge > 0 && <div className="flex justify-between"><span>Service Charge</span><span>{fmtAED(invoice.service_charge)}</span></div>}
        <div className="flex justify-between font-bold text-sm border-t border-dashed border-gray-400 pt-1 mt-1"><span>TOTAL</span><span>{fmtAED(invoice.grand_total)}</span></div>
      </div>
      <div className="text-xs mt-2">
        {(invoice.payments || []).map((p, i) => <div key={i} className="flex justify-between capitalize"><span>Paid ({p.method})</span><span>{fmtAED(p.amount)}</span></div>)}
      </div>
      <div className="text-center text-xs mt-3 border-t border-dashed border-gray-400 pt-2">{footer || 'Thank you!'}</div>
    </div>
  );
}
